/** Keeps optional public data failures from turning an entire page into HTTP 500. */
export async function safeLoader<T>(
  label: string,
  load: () => Promise<T>,
  fallback: T,
): Promise<T> {
  try {
    return await load();
  } catch (error) {
    console.error(`Public loader fallback: ${label}`, error);
    return fallback;
  }
}